export enum ImmoTaskType {
  TASK,
  COLLECT_KEY,
}
